import {
  ATTRIBUTE_NAME_PACKAGE_SIZE,
  ATTRIBUTE_NAME_PACKAGING_VARIANT,
} from './ATTRIBUTE_NAME'
import {
  type AttributeGroups,
  type AttributeSelectionRenderGroups,
} from './AttributeGroup'
import { ATTRIBUTE_VALUE_PACKAGING_VARIANT_SET } from './calcProductPageAttributesSelectionState'

const TWO = 2
/**
 * in case attributes are packaging size and packaging_variant, and packaging_variant has only set value,
 * on mobile screen only packaging_size should be displayed.
 * for details: https://jira.shop-apotheke.com/browse/WSHOME-539
 */
const isAttributePackagingVariantWithSetValueEdgecase = (
  attributeGroups: AttributeGroups,
): boolean => {
  if (Object.values(attributeGroups).length !== TWO) {
    return false
  }

  const groups = Object.values(attributeGroups)

  const packagingSizeGroup = groups.some(
    (group) =>
      group?.metaAttributeData.variant_attribute ===
      ATTRIBUTE_NAME_PACKAGE_SIZE,
  )
  const packagingVariantGroup = groups.find(
    (group) =>
      group?.metaAttributeData.variant_attribute ===
      ATTRIBUTE_NAME_PACKAGING_VARIANT,
  )

  if (
    !packagingSizeGroup ||
    // false - packaging_variant group contains multiple attributes
    packagingVariantGroup?.selectionEntries.length !== 1
  ) {
    return false
  }

  // packaging_variant contains only attribute with value 'set'
  return (
    packagingVariantGroup.selectionEntries[0].attribute.value ===
    ATTRIBUTE_VALUE_PACKAGING_VARIANT_SET
  )
}

/**
 * on mobile, in cases when:
 * - we have only packaging size for all variants.
 * - OR we have packaging size and packaging_variant with single value "SET"
 */
export const getHasSingleRenderGroup = (
  renderGroups: AttributeSelectionRenderGroups,
  attributeGroups: AttributeGroups,
  isSingleRenderGroup: boolean,
): boolean => {
  /**
   * edgecase, see method docs
   */
  if (isAttributePackagingVariantWithSetValueEdgecase(attributeGroups)) {
    return true
  }

  const groups = Object.values(attributeGroups)

  /**
   * edgecase:
   * if 2 products have packaging_size and e.g. color
   * and one product has only packaging_size - we should not render mobile view for this product
   */
  if (isSingleRenderGroup && groups.length > 1) {
    return false
  }

  return (
    isSingleRenderGroup &&
    renderGroups[0]?.group?.metaAttributeData?.variant_attribute ===
      ATTRIBUTE_NAME_PACKAGE_SIZE
  )
}
